"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSize = exports.font = void 0;
var FONT_LIGHT = 'Tele2Sans-Light';
var FONT_REGULAR = 'Tele2Sans-Regular';
var FONT_MEDIUM = 'Tele2Sans-Medium';
exports.font = {
    FONT_LIGHT: FONT_LIGHT,
    FONT_MEDIUM: FONT_MEDIUM,
    FONT_REGULAR: FONT_REGULAR,
};
exports.fontSize = {
    XS: '8px',
    SM: '10px',
    MD: '12px',
    LG: '14px',
    XL: '16px',
    XXL: '18px',
    XXXL: '20px',
    XXXXL: '24px',
    XXXXXL: '32px',
    XXXXXXL: '40px',
    XXXXXXXL: '48px',
};
